import { render, staticRenderFns } from "./ListTipo.vue?vue&type=template&id=e51ae10c"
import script from "./ListTipo.vue?vue&type=script&lang=js"
export * from "./ListTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports